<script>
export default {
  name: "StartRisk"
}
</script>

<template>
<div>
  <h1>Start Your Risk-Free Trial</h1>
  <b-card-sub-title style="font-size: x-large">Get samples within 5 days!</b-card-sub-title>
  <p class="text-left font-weight-bold" style="padding-top: 80px">4 Precision Process to Ensure your Quality
    package.</p>
  <p class="text-left font-weight-bold">
    Quality isn’t Expensive, Quality is Priceless.
  </p>

  <b-card class="overflow-hidden border-0 rounded-0" style="padding-bottom: 80px; padding-top: 20px">
    <b-row no-gutters align-v="center">
      <b-col md="3">
        <b-card-img-lazy src="@/assets/4-1.jpg"></b-card-img-lazy>
      </b-col>
      <b-col md="9">
        <b-card-body style="margin-left: 20px">
          <h2>Material Sourcing & Preparation</h2>
          <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
            We select and procure the exact paper stock or substrates, which are then precision-cut to the
            required
            dimensions.
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
  <b-card class="overflow-hidden border-0 rounded-0" style="padding-bottom: 80px; padding-top: 80px">
    <b-row no-gutters align-v="center">
      <b-col md="9">
        <b-card-body style="margin-right: 20px">
          <h2>Printing & Color Application</h2>
          <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
            Your design is brought to life using advanced printing techniques (like offset or digital) for
            vibrant,
            brand-accurate colors.
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col md="3">
        <b-card-img-lazy src="@/assets/4-2.jpg"></b-card-img-lazy>
      </b-col>
    </b-row>
  </b-card>
  <b-card class="overflow-hidden border-0 rounded-0" style="padding-bottom: 80px; padding-top: 80px">
    <b-row no-gutters align-v="center">
      <b-col md="3">
        <b-card-img-lazy src="@/assets/4-3.jpg"></b-card-img-lazy>
      </b-col>
      <b-col md="9">
        <b-card-body style="margin-left: 20px">
          <h2>Die-Cutting & Precision Assembly</h2>
          <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
            The printed sheets are die-cut into their final shape and then meticulously folded, glued, or
            assembled by
            skilled crafters.
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
  <b-card class="overflow-hidden border-0 rounded-0" style="padding-bottom: 80px; padding-top: 80px">
    <b-row no-gutters align-v="center">
      <b-col md="9">
        <b-card-body style="margin-right: 20px">
          <h2>Final Quality Check & Packing for Shipment</h2>
          <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
            Every unit undergoes a rigorous final inspection before being carefully packed and prepared for secure
            delivery to you.
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col md="3">
        <b-card-img-lazy src="@/assets/4-4.jpg"></b-card-img-lazy>
      </b-col>
    </b-row>
  </b-card>
</div>
</template>

<style scoped lang="scss">

</style>